import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        course: '=',
        scormCourses: '<',
        context: '=',
        forms: '=',
        company: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        isDisabled: '<',
        hasPlanningGroups: '<',
        ckconfig: '<',
        trainingTypes: '<',
        save: '&'
    },
    template: `
        <div>
            <div class="block07 mt20">
                <div class="row row-wide">
                    <label class="label">{{ 'courses.Materials source' | translate }}</label>
                    <div class="items w100p">
                        <ul class="checkboxes">
                            <li>
                                <label ng-repeat="value in vm.materialTypes">
                                    <input ng-disabled="vm.isDisabled"
                                    ng-click="vm.CourseVersionTrainingFormService.finalizePassingType(vm.trainingForm)"
                                    name="r05"
                                    type="radio"
                                    ng-model="vm.trainingForm.materialType"
                                    ng-value="'{{ value }}'"> {{ vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.LABELS[value] }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row-wide" ng-if="vm.trainingForm.materialType===vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.LEARNDASH"
            error="vm.form.errors.courseTrainings[vm.key].learndashCourseId">
            <label class="label w100p">{{ 'courses.Learning materials' | translate }}</label>
            <div class="items w100p">
                <select ng-disabled="vm.isDisabled" class="form-control"
                    ng-model="vm.trainingForm.learndashCourseId"
                    ng-change="vm.CourseVersionTrainingFormLearndashService.getLearndashCourse(vm.trainingForm)"
                    ng-options="course.ID as course.post_title for course in vm.CourseVersionTrainingFormLearndashService.learndashCourses">
                    <option value=""></option>
                </select>
            </div>
            <div>
                <p class="desc warn" ng-if="!vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)">
                    {{ 'courses.Saved value is not displayed. You do not have access to the attached material' | translate }}
                </p>
                <a
                    style="margin: 0 20px 0 0"
                    class="btn add"
                    ng-if="!vm.isDisabled
                    && (vm.PrivilegeService.canManageMaterials() || vm.CourseVersionTrainingFormLearndashService.hasManageMaterialsPrivilegeSite())
                    && vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)"
                    ng-click="vm.CourseVersionTrainingFormLearndashService.addLdMaterial(vm.trainingForm)"
                >
                    {{ 'courses.Add study material' | translate }}
                </a>
                <a
                    style="margin: 0 20px 0 0"
                    class="btn edit"
                    ng-if="vm.canManageCourse
                    && vm.PrivilegeService.canManageMaterials()
                    && vm.trainingForm.canEditLearndashCourse
                    && vm.CourseVersionTrainingFormLearndashService.showLearndashCourseEditLink
                    && vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)"
                    ng-click="vm.CourseVersionTrainingFormLearndashService.editLdMaterial(vm.trainingForm)"
                >
                    {{ 'courses.Edit study material' | translate }}
                </a>
            </div>
        </div>
        <div ng-if="vm.trainingForm.materialType===vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.SCORM">
            <form-row error="vm.form.errors.courseTrainings[vm.key].scormCourseId"
                ng-if="vm.TokenService.isScormCloudEnabled() && vm.CourseVersionTrainingFormScormService.showScormMaterials(vm.trainingForm, vm.scormCourses)">
                <label class="label">{{ 'courses.Learning materials' | translate }}</label>
                <div class="items">
                    <select ng-disabled="vm.isDisabled" class="form-control"
                        ng-model="vm.trainingForm.scormCourseId"
                        ng-options="course.id as course.title for course in vm.scormCourses">
                        <option value=""></option>
                    </select>
                    <p class="desc warn" ng-if="!vm.CourseVersionTrainingFormScormService.hasAccessToScormStudyMaterials(vm.trainingForm.scormCourseId, vm.scormCourses)">
                        {{ 'courses.Saved value is not displayed. You do not have access to the attached material' | translate }}
                    </p>
                    <a class="btn view" ng-if="vm.trainingForm.scormCourseId && vm.CourseVersionTrainingFormScormService.hasAccessToScormStudyMaterials(vm.trainingForm.scormCourseId, vm.scormCourses)"
                            ng-click="vm.CourseVersionTrainingFormScormService.launchScormPreview(vm.trainingForm.scormCourseId)"
                        >{{ 'courses.Preview' | translate }}</a>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </div>
        <div ng-if="vm.trainingForm.materialType===vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM">
            <scorm-content
                loading="vm.loading"
                context="vm.context"
                is-disabled="vm.isDisabled"
                form="vm.form"
                training-form="vm.trainingForm"
                key="vm.key"
            ></scorm-content>
        </div>
        <div ng-if="vm.trainingForm.materialType===vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT">
            <div class="mt20">
                <div class="alert alert-plain"
                    ng-class="{'error': vm.form.errors.courseTrainings[vm.key].materials}"
                    style="
                        display: flex;
                        gap: 20px;
                        align-items: flex-start;
                        flex-wrap: wrap;
                    ">
                    <div>
                        <p style="margin-top: 0;" class="muted" ng-if="!vm.material">
                            {{ 'version.No material has been created yet' | translate }}
                        </p>
                        <ul class="actions01" ng-if="!vm.material">
                            <li class="nomargin">
                                <a class="btn main ico-popup" ng-disabled="vm.course.isArchived" ng-click="vm.contentEditor('editor')">
                                    {{ 'version.Open content editor' | translate }}
                                </a>
                            </li>
                        </ul>

                        <div class="iframe-container" ng-if="vm.material">
                            <div class="material-shortcut" style="margin-bottom: 10px;">
                                <courses-authoring-tool-view
                                    view-only="true"
                                    ng-show="vm.iframeLoaded"
                                    material="vm.material"
                                    company="vm.company"
                                />
                            </div>
                            <loader-icon ng-if="!vm.iframeLoaded"></loader-icon>
                            <ul class="actions01">
                                <li class="nomargin">
                                    <a class="btn main ico-popup"
                                    ng-disabled="vm.course.isArchived"
                                    style="border-radius: 6px;"
                                    ng-click="vm.contentEditor('editor')">
                                        {{ 'version.Open content editor' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div ng-if="vm.material">
                        <ul style="padding-left: 20px; margin: 0 0 8px;">
                            <li ng-repeat="lang in vm.companySupportedLanguages"
                                ng-if="vm.getMaterialChaptersCount(lang)">
                                    {{ vm.COMPANY_LANGUAGE_ENUM.LABELS[lang] }}: {{ vm.getMaterialChaptersCount(lang) }} <span
                                        ng-if="vm.getMaterialChaptersCount(lang) === 1"
                                    >{{ 'authoringTool.chapter' | translate }}</span>
                                    <span
                                        ng-if="vm.getMaterialChaptersCount(lang) > 1"
                                    >{{ 'authoringTool.chapters' | translate }}</span>
                                    <span ng-if="vm.getMaterialHiddenChaptersCount(lang)">
                                        ({{ vm.getMaterialHiddenChaptersCount(lang) }}
                                        {{ 'authoringTool.hidden' | translate }})
                                    </span>
                            </li>
                        </ul>
                        <p class="desc muted" style="margin-left:1em" ng-if="vm.material.updatedAt || vm.material.createdAt">
                            {{ 'version.Last modified' | translate }}: {{ vm.getLastModifiedDate(vm.material) }}
                        </p>
                    </div>
                </div>
                <div class="alert alert-warn has-icon" ng-if="vm.form.warnings.courseTrainings[vm.key].materials">
                    <img class="alert-icon" alt="Needs attention" src="assets/css/icon_warn.svg">
                    {{ vm.form.warnings.courseTrainings[vm.key].materials }}
                </div>
            </div>
        </div>
    <style>
        .iframe-container {
            width: 400px;
            height: 300px;
            overflow: hidden;
            position: relative; /* Ensures child elements (like loader) are contained */
            border-radius: 0 0 10px 10px;
            border: 1px solid rgb(171, 171, 171);
            background: white;
        }

        .iframe-container #preloader {
            position: absolute !important; /* Restrict inside container */
            top: 0;
            left: 0;
            width: 100% !important;
            height: 100% !important;
            background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
            z-index: 5;
        }

        .iframe-container .material-shortcut {
            all: unset; /* Resets all inherited styles */
            display: block; /* Restore display */
            transform: scale(0.3);
            transform-origin: top left;
            width: 1333px;
            height: 870px;
            border: 0;
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
        }
        .iframe-container a {
            position: absolute !important;
            top: 260px;
        }
        .material-shortcut a {
            all: unset;
            position: relative !important;
        }
    </style>
    `
})

export default class {
    constructor (TokenService, lodash, CourseVersionService, PrivilegeService, CourseVersionTrainingFormService, Upload, $rootScope,
                 CourseVersionTrainingFormLearndashService, CourseVersionTrainingFormFileService, CourseVersionTrainingFormScormService,
                 CourseVersionTrainingFormCoursyScormService, COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM, moment,
                 COMPANY_LANGUAGE_ENUM, ResponseService, COURSE_TRAINING_MATERIAL_TYPE_ENUM, ModalService, ScormSubmissionResource, $translate, $window, $state, $scope,
                 CourseVersionTrainingFormMaterialService, $timeout) {
        this.TokenService = TokenService;
        this.lodash = lodash;
        this.moment = moment;
        this.Upload = Upload;
        this.ResponseService = ResponseService;
        this.CourseVersionService = CourseVersionService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionTrainingFormService = CourseVersionTrainingFormService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.CourseVersionTrainingFormScormService = CourseVersionTrainingFormScormService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.CourseVersionTrainingFormMaterialService = CourseVersionTrainingFormMaterialService;
        this.CourseVersionTrainingFormCoursyScormService = CourseVersionTrainingFormCoursyScormService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.$scope = $scope;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        this.ModalService = ModalService;
        this.ScormSubmissionResource = ScormSubmissionResource;
        this.$translate = $translate;
        this.$window = $window;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.loading = false;

        this.chunkIndex = this.totalChunks = 0;

        this.materialTypes = this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS;
        delete this.materialTypes.FILE;
        if (!TokenService.isScormCloudEnabled()) {
            delete this.materialTypes.SCORM;
        }

        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        // material preview
        this.setMaterial();

        $scope.$on('$destroy', () => {
            this.material = null;
        });

        $scope.$on('material:init', () => {
            if (this.form.errors.courseTrainings !== undefined) {
                delete this.form.errors.courseTrainings[this.key];
            }
            this.setMaterial();
        });
        $scope.$on('authoringTool:preview', () => {
            this.contentEditor('preview');
        });
    }

    getLastModifiedDate (material) {
        if (!material.updatedAt) {
            return this.moment.unix(material.createdAt).format('DD.MM.YYYY HH:mm');
        }
        return this.moment.unix(material.updatedAt).format('DD.MM.YYYY HH:mm');
    }

    getMaterialChaptersCount (lang) {
        let count = 0;
        this.lodash.forEach(this.trainingForm.materials, material => {
            if (material.lang === lang && material.isEnabled) {
                count = material.chapters.length;
            }
        });
        return count;
    }

    getMaterialHiddenChaptersCount (lang) {
        const material = this.lodash.find(this.trainingForm.materials, item => item.lang === lang && item.isEnabled);
        if (!material) {
            return 0;
        }
        return this.lodash.filter(material.chapters, chapter => chapter.isVisible === false).length;
    }

    setMaterial () {
        this.material = null;
        if (this.trainingForm.materials === undefined || !this.trainingForm.materials.length) {
            this.iframeLoaded = true;
            this.material = null;
            return;
        }
        this.trainingForm.materials = this.CourseVersionTrainingFormMaterialService
            .transformMaterialsFromApi(this.trainingForm.materials);
        this.iframeLoaded = false;
        // is needed to update state of material container
        this.$timeout(() => {
            let material = this.trainingForm.materials.find(item => item.lang === this.defaultLanguage);

            if (!material || !material.chapters.length) {
                material = this.trainingForm.materials.find(item => item.isEnabled
                    && this.lodash.includes(this.companySupportedLanguages, item.lang));
                if (material && material.chapters.length) {
                    this.material = material;
                }
            }
            else {
                this.material = material;
            }
        }, 10);

        // timeout to ensure preview is fully loaded
        this.$timeout(() => {
            this.iframeLoaded = true;
        }, 900);
    }

    $onInit () {
        // get the course in order to assign showLearndashCourseEditLink the right way
        this.CourseVersionTrainingFormLearndashService.getLearndashCourse(this.trainingForm);
        this.CourseVersionTrainingFormCoursyScormService.setScormFiles();

        if (!this.trainingForm.materialType) {
            this.trainingForm.materialType = this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.LEARNDASH;
        }
    }

    showLdMaterials (trainingForm) {
        return !this.TokenService.isScormCloudEnabled() || !trainingForm.materialType || trainingForm.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.LEARNDASH;
    }

    contentEditor (viewMode) {
        const { trainingForm, context, course } = this;

        if (this.course.isArchived && viewMode === 'editor') {
            return null;
        }

        return this.ModalService.open({
            size: 'full',
            template: `
                <modals-courses-authoring-tool-editor
                    class="wrapper"
                    course="vm.course"
                    uib-modal-instance="vm.$uibModalInstance"
                    training-form="vm.trainingForm"
                    context="vm.context"
                    company="vm.company"
                    view-mode="vm.viewMode"
                />`,
            resolve: {
                company (CompanyResource, TokenService) {
                    return CompanyResource.publicView({ id: TokenService.getCompanyId() }).$promise;
                }
            },
            controller ($uibModalInstance, company) {
                this.trainingForm = trainingForm;
                this.viewMode = viewMode;
                this.context = context;
                this.company = company;
                this.course = course;
                this.$uibModalInstance = $uibModalInstance;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/online/index.js